// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__5D6-H","errorLogs":"styles_errorLogs__n6ohJ"};